
import React, { useState, useContext, useCallback, useEffect, useRef } from "react"
import { AppContext } from '../../../context'
import { themeColor } from "../../layout/global-style";
import Logo from '../../atoms/logo/index'
import { Subtitle } from '../../atoms/subtitle/index'
import {Compass} from "../../atoms/compass/index"
import {
  Container,
  Content,
  ListContainer,
  LogoContainer,
  Wrapper,
  LangSelectionContainer,
  LocaleContainer
} from './styles';

import HudButton from "../../molecules/hudButton";
import { changeLocale, FormattedMessage, useIntl } from "gatsby-plugin-intl"
import { Fade } from "../../atoms/fade";
import { timeout } from "../../../utils/useTimeout";
import Title from '../../atoms/title/index'
import Icon, { IconType } from "../../atoms/icon";

const LocaleItem = ({ label, locale}) => {
  const { setLangSelection , audio, setAutoStartPage, setPageTransition, current: currentPage} = useContext(AppContext);
  const [clicked, setClicked] = useState(false);

  const {locale: current} = useIntl();

  const transitionTimerRef = useRef();
  const transitionDuration = 100;

  useEffect(() => {
    if (clicked) {

      clearTimeout(transitionTimerRef.current);
      function tick() {
        setLangSelection(false);
      }
      transitionTimerRef.current = setTimeout(tick, transitionDuration ); 
      return () => {
        clearTimeout(transitionTimerRef.current);
      }
    }    
  }, [clicked])

  const execChangeLocale = async () => {
      setPageTransition(true);
      setAutoStartPage(Math.floor(currentPage / 2) * 2);
      await timeout(300);
      changeLocale(locale);
  }

  const onClick = useCallback(
    () => {
      if (!isCurrent) {
        execChangeLocale();
      }
      setClicked(true);
    },
    [isCurrent, locale, currentPage],
  )
  const isCurrent = current === locale;
  const currIcon = isCurrent ? <Icon type={IconType.tick} /> : null;

  return (
    <LocaleContainer>
      <HudButton
        onClick={onClick}
        fontColor={isCurrent ? themeColor.white : themeColor.black}
        color={themeColor.black} 
        frame
      >{currIcon}
        {label}
      </HudButton>
    </LocaleContainer>
  )
}

const LangSelection = () => {
  const { availableLocale} = useContext(AppContext);
  const ListLocale = availableLocale.map((item, index) => <LocaleItem key={index} index={index} {...item} />);
  return (
    <LangSelectionContainer>
      <Subtitle color={themeColor.black}><FormattedMessage id="chooseLanguage.subtitle" defaultMessage="Choose Language :"/></Subtitle>
      <ListContainer>
        {ListLocale}
      </ListContainer>
    </LangSelectionContainer>
  )
}

export const LangSelectionPage = ({ isOpen }) => 
  <Fade isShow={isOpen}>
    <Container >
      <Compass />
      <Wrapper>
        <Content>
          <LogoContainer>
            <Logo />
          </LogoContainer>
          <Title color={themeColor.black} messageid={"app.title"}/>
          <Subtitle color={themeColor.black}><FormattedMessage id="app.subtitle" /></Subtitle>
          <LangSelection />
        </Content>
      </Wrapper>
    </Container>
  </Fade>

export default () => {
  const { langSelection } = useContext(AppContext)
  return (
    <LangSelectionPage isOpen={langSelection} />
  )
};
